import { FormControlLabel, Switch, styled, withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { green } from '@material-ui/core/colors';
import React from 'react';

const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                opacity: 1,
                border: 0
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
            }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff'
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : 'lightgrey',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));

export const PrimaryCheckbox = (props) => {
    return <Checkbox inputProps={{ 'aria-label': 'primary checkbox' }} {...props} />;
};

export const SecondaryCheckbox = (props) => {
    return <Checkbox inputProps={{ 'aria-label': 'secondary checkbox' }} {...props} />;
};

export const IosSwitch = (props) => {
    return <FormControlLabel control={<IOSSwitch {...props} />} />;
};

const UnderlyingCheckBox = ({ props, isPrimary }) => {
    const { forceEditable, ...rest } = props;

    return <Checkbox color={isPrimary ? 'primary' : 'secondary'} inputProps={{ 'aria-label': `${isPrimary ? 'primary' : 'secondary'} checkbox` }} {...rest} />;
};

const CustomCheckBox = ({ props, isPrimary, label }) => {
    return <FormControlLabel control={<UnderlyingCheckBox props={props} isPrimary={isPrimary} />} label={label} />;
};

export const PrimaryCheck = (props) => {
    return <CustomCheckBox props={props} isPrimary={true} label={props.label || ''} />;
};

export const SecondaryCheck = React.memo((props) => {
    return <CustomCheckBox props={props} isPrimary={false} label={props.label || ''} />;
});

export const GreenCheckbox = withStyles({
    root: {
        color: 'grey',
        '&$checked': {
            color: green[600]
        }
    },
    checked: {}
})((props) => <Checkbox color="default" {...props} />);
